/* Diamond Domain - places the shipping note (Sep 2026).

   Rendered by layout/theme.liquid and moved next to the shipping estimate here, which avoids
   editing templates/product.json.

   For ready-to-ship stock it also HIDES the theme's estimator. That block is a custom code
   snippet that blindly adds processing + shipping days to today, so it was promising an
   October date on a ring that is already finished and boxed. Two contradictory shipping
   claims on one page is worse than either alone.

   Delete this file and its line in layout/theme.liquid to revert. */
(function () {
  var ID = 'dd-ship-note';

  var CSS =
    '.dd-ship-note{margin-top:8px;padding:11px 14px;border-left:2px solid #1b3b32;' +
    'background:#f7f6f3;font-size:14px;line-height:1.6;font-weight:400;color:#3a352e;}' +
    '.dd-ship-note strong{color:#1b3b32;font-weight:500;}' +
    '.dd-ship-note a{color:#1b3b32;text-decoration:underline;text-underline-offset:2px;}' +
    '.dd-ship-note--ready{border-left-color:#1b3b32;background:#eef3f0;}';

  function style() {
    if (document.getElementById(ID + '-css')) return;
    var s = document.createElement('style');
    s.id = ID + '-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function place() {
    var note = document.getElementById(ID);
    if (!note) return true;
    if (note.dataset.ddPlaced === '1') return true;

    var est = document.getElementById('estimated-delivery');
    if (!est) return false;

    var ready = note.getAttribute('data-dd-ready') === 'true';

    style();
    est.parentNode.insertBefore(note, est.nextSibling);
    note.hidden = false;
    note.dataset.ddPlaced = '1';

    /* the generic estimator is wrong for stock that is already made */
    if (ready) est.style.display = 'none';

    return true;
  }

  function start() {
    if (place()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (place() || ++tries > 20) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();